export default function createPaginatorVariables(
  tags,
  category,
  limit,
  endCursor
) {
  const paginator = {};
  if (tags) {
    paginator.limit = limit;
    paginator.tags = tags;
  } else if (category) {
    paginator.limit = limit;
    paginator.categories = [category];
  }

  if (endCursor) {
    paginator.cursor = endCursor;
  }
  return paginator;
}
